import { deleteRequest, get, post, put } from "utils/api";

// SQUARE-SPACE
export const getContactInfo = async contact => {
  const addResponse = await get(`/squarespace/get-retail-info/${contact}`);
  return addResponse.data;
};

export const searchContact = async contact => {
  const addResponse = await get(`/squarespace/get-contact-information/${contact}`);
  return addResponse.data;
};

export const sendInvoice = async data => {
  const addResponse = await post(`/squarespace/create-invoice`, data);
  return addResponse.data;
};

// HUBSPOT
export const importHubspotContacts = async data => {
  const addResponse = await post(`/hubspot/createContact`, data);
  return addResponse.data;
};

export const saveHubspotToken = async data => {
  const addResponse = await post(`/hubspot/save-refresh-token`, data);
  return addResponse.data;
};

export const savePipedriveToken = async payload => {
  const response = await post("/pipedrive/save-refresh-token", payload);
  return response.data;
};

export const hubspotFieldList = async () => {
  const addResponse = await get(`/hubspot/fetch-properties`);
  return addResponse.data;
};

export const removeAccount = async data => {
  const deleteResponse = await deleteRequest("/user/removeAccount", data);

  return deleteResponse.data;
};

export const getMessageById = async data => {
  const messageResponse = await get(`/auth/hs/message/${data}`);

  return messageResponse.data;
};

// ZOHO
export const zohoFields = async params => {
  const addResponse = await get(`/zoho/fetch-fields?crmModule=${params}`);
  return addResponse.data;
};

export const saveZohoToken = async data => {
  const addResponse = await post(`/zoho/save-refresh-token`, data);
  return addResponse.data;
};

export const importZohoContacts = async data => {
  const addResponse = await post(`/zoho/createContact`, data);
  return addResponse.data;
};

// GHL
export const saveGHLToken = async data => {
  const addResponse = await post(`/ghl/save-refresh-token`, data);
  return addResponse.data;
};

export const saveGHLConfiguration = async (data, id) => {
  const response = await post(`/user/subaccount-ghl-webhook/${id}`, data);
  return response.data;
};

export const removeGHLConfiguration = async (data, id) => {
  const response = await deleteRequest(`/user/subaccount-ghl-webhook/${id}`, data);
  return response.data;
};

export const getSenderToAssign = async args => {
  const response = await get(`/integrations/ghl/senders/available`, args);
  return response.data;
};

export const getGHLAccounts = async args => {
  const response = await get(`/integrations/ghl/accounts`, args);
  return response.data.data;
};

export const assignDefaultSender = async (id, data) => {
  const response = await post(`/integrations/ghl/assign-sender/${id}`, data);
  return response.data;
};

export const getGHLAccountStats = async () => {
  const response = await get(`/integrations/ghl/subaccount/dashboard`);
  return response.data;
};

export const getGHLAccountConnection = async () => {
  const response = await get(`/integrations/ghl/connected-accounts`);
  return response.data;
};

export const configureBilling = async (id, data) => {
  const response = await post(`/integrations/ghl/configure-billing/${id}`, data);
  return response.data;
};

export const removeGHIntegration = async data => {
  const response = await post(`/integrations/ghl/remove-connection?subAccount=${data.subAccount}`);
  return response.data;
};

export const sendGHLWebhook = async data => {
  let url = "/integrations/ghl/send-webhook";

  if (data.dedicatedNumberWebhook) {
    url += `?webhook=${data.dedicatedNumberWebhook}`;
  }

  const response = await post(url, data);
  return response.data;
};

export const saveGHLWebhook = async data => {
  const response = await post(`/integrations/ghl/save-webhook`, data);
  return response.data;
};

export const reConnectGHLAccount = async id => {
  const response = await get(`/integrations/ghl/reconnect/${id}`);
  return response.data;
};

export const getGHLWebhookLogs = async (subAccountId, page = 1) => {
  const params = { subAccount: subAccountId };
  if (page > 1) {
    params.page = page;
  }
  const response = await get(`/integrations/ghl/webhook-logs`, params);
  return response.data;
};

export const resendAnalyticsData = async (subAccount, webhookLogId = null) => {
  let url = `/integrations/ghl/resendAnalyticsData/${subAccount}`;

  if (webhookLogId) {
    url += `?webhookLogId=${webhookLogId}`;
  }

  const response = await post(url);
  return response.data;
};

export const generateBillingReport = async (subAccount, payload) => {
  const response = await post(`/integrations/ghl/billingReport/${subAccount}`, payload);
  return response.data;
};

export const getBillingReportPreview = async (subAccount, payload) => {
  const queryParams = new URLSearchParams({
    from: payload.from,
    to: payload.to,
    type: payload.type
  }).toString();

  const response = await get(`/integrations/ghl/billingReport/${subAccount}?${queryParams}`);
  return response.data;
};

export const getDedicatedNumberAnalytics = async (subAccount, payload = {}) => {
  const query = new URLSearchParams();
  if (payload.from) query.append("from", payload.from);
  if (payload.to) query.append("to", payload.to);
  const queryString = query.toString();
  const url = `/integrations/ghl/get-dedicated-number-analytics/${subAccount}${queryString ? `?${queryString}` : ""}`;
  const response = await get(url);
  return response.data;
};

export const generateDedicatedNumberAnalyticsReport = async (subAccount, payload = {}) => {
  const response = await post(`/integrations/ghl/send-dedicated-number-analytics/${subAccount}`, payload);
  return response.data;
};

export const fireTestBillingEvent = async (subAccount, payload) => {
  const response = await post(`/integrations/ghl/fire-test-billing-event/${subAccount}`, payload);
  return response.data;
};

// ACTIVE CAMPAIGN

export const saveActiveCampToken = async data => {
  const addResponse = await post(`/ac/save-token`, data);
  return addResponse.data;
};

export const activeCamapaignFeilds = async data => {
  const addResponse = await get(`/ac/fetch-fields`, data);
  return addResponse.data;
};

export const activeCamapaignFilter = async data => {
  const addResponse = await get(`/ac/fetch-filters`, data);
  return addResponse.data;
};

export const importACContacts = async data => {
  const addResponse = await post(`/ac/createContact`, data);
  return addResponse.data;
};

export const pipedriveFieldList = async data => {
  const addResponse = await get(`/auth/pipedrive/fetch-properties`);

  return addResponse.data;
};

export const importPipedriveContacts = async data => {
  const addResponse = await post("/auth/pipedrive/createContacts", data);

  return addResponse.data;
};

// CONVERSATION APP
export const createDomainApproval = async data => {
  const response = await post(`/integrations/conversation/domains`, data);
  return response.data;
};

export const fetchAllDomainApprovals = async (params = {}) => {
  const response = await get(`/integrations/conversation/domains`, params);
  return response.data;
};

export const updateDomainApprovalStatus = async (id, data) => {
  const response = await put(`/integrations/conversation/domains/${id}`, data);
  return response.data;
};

export const fetchUserDomainApprovals = async (params = {}) => {
  const response = await get(`/integrations/conversation/domains/me`, { params });
  return response.data;
};

export const deleteDomainApproval = async id => {
  const response = await deleteRequest(`/integrations/conversation/domains/${id}`);
  return response.data;
};

export const getDomainToken = async (id, new_token) => {
  let url = `/integrations/conversation/domains/${id}`;

  if (typeof new_token !== "undefined") {
    url += `?new_token=${new_token}`;
  }

  const response = await get(url);
  return response.data;
};
